import { Booking } from '../Shared/Types/bookingTypes';
import { AutomaticBookings } from './Types/booking.types';
import { today } from '../Shared/Helpers/dateHelpers';

export const bookingValues: Booking = {
  id: 0,
  offerId: 0,
  numberOfParticipants: 0,
  price: 0,
  published: false,
  possibilityOfReservation: false,
  bookingStatusName: '',
  bookingDateFrom: today(),
  bookingDateTo: today(),
};
export const initialAutomaticBookings: AutomaticBookings = {
  offerId: 0,
  numberOfParticipants: 0,
  possibilityOfReservation: false,
  price: 0,
  published: false,
  bookingStatusName: '',
  startDate: '',
  durationInDays: 0,
  offsetDays: 0,
  numberOfBookings: 1,
  id: 0,
};
